<template>
	<article class="small-12 residentProfile flex justify-center vertical-align animated fadeIn borderRadius8" :style="profileBackgroundStyle" v-if="resident && unit">
        <div class="small-11 columns profileWrap borderRadius8">
            <div class="small-12 avatar flex vertical-align">
                <div class="small-9 flex vertical-align">
                    <picture class="round flex justify-center vertical-align">
                        <span>{{ resident.attributes.contact_information.first_name | abbreviateName }}{{ resident.attributes.contact_information.last_name | abbreviateName }}</span>
                    </picture>
                    <div class="small-9 name">
                        <h1 class="small-12">{{ resident.attributes.contact_information.first_name }} {{ resident.attributes.contact_information.last_name }}</h1>
                        <ul class="small-12 float-left flex vertical-align">
                            <li class="small-12 flex vertical-align">
                                <p>{{unit.attributes.address.street_1}}</p>
                                <span class="round bgPrimaryBlue"></span>
                                <p>Unit {{ unit.attributes.number }}</p>
                            </li>
                        </ul>
                        <h6 class="small-12">{{ resident.attributes.contact_information.email }}</h6>
                        <h6 class="small-12">{{ resident.attributes.contact_information.phone_number }}</h6>
                    </div>
                </div>
                <div class="small-3 unitButton flex justify-right">
                    <router-link :to="{ name: 'Unit', params: { id: $route.params.id, unitID: unit.id } }" class="purpleButton flex vertical-align borderRadius4">
                        <i class="material-icons addIcon borderRadius4 flex justify-center vertical-align">home</i>
                        View Unit
                    </router-link>
                </div>
            </div>
            <div class="small-12 border-top rentBreakdown">
                <div class="small-12 columns totalRent flex vertical-align">
                    <p class="auto float-left" v-if="totalMonthlyRent > 0">${{ totalMonthlyRent | convertCentsToDollars}}</p>
                    <p class="auto float-left" v-else>$0.00</p>
                    <span class="auto float-left metricLabel">Monthly Rent</span>
                    <span class="round bgPrimaryBlue"></span>
                    <span class="auto badge bgPurple borderRadius4" v-if="!lease">No Active Lease</span>
                    <span class="auto badge bgPurple borderRadius4" v-else-if="!rent">No Active Rent Term</span>
                    <span class="auto badge bgRed borderRadius4" v-else-if="rent && rent.attributes.status == 'late'">Late</span>
                    <span class="auto badge bgPrimaryBlue borderRadius4" v-else>Current</span>
                </div>
                <ul class="small-12 columns flex vertical-align float-left">
                    <li class="auto">
                        <p>
                            <b v-if="rent && rent.attributes.amount > 0">${{ rent.attributes.amount | convertCentsToDollars}}</b>
                            <b v-else>$0.00</b>
                            <span>Monthly Rent</span>
                        </p>
                    </li>
                    <li class="auto">
                        <span class="operator">+</span>
                    </li>
                    <li class="auto">
                        <p class="flex vertical-align">
                            <b v-if="rent && rent.attributes.transaction_fees_policy.set_policy && rent.attributes.transaction_fees_policy.resident.fee_amount > 0">${{ rent.attributes.transaction_fees_policy.resident.fee_amount | convertCentsToDollars}}</b>
                            <b v-else>$0.00</b>
                            <span>Transaction Fee</span>
                        </p>
                    </li>
                    <li class="auto">
                        <span class="operator">=</span>
                    </li>
                    <li class="auto">
                        <p>
                            <b v-if="totalMonthlyRent > 0">${{ totalMonthlyRent | convertCentsToDollars}}</b>
                            <b v-else>$0.00</b>
                            <span>Total Monthly Rent</span>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </article>
</template>

<script>

    // Import the filters
    import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'
    import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ResidentDetails',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			AbbreviateNameFilter,
            MoneyConversions

		],

		/*
		**  Set the props
		*/

		props: {

			resident: {
                type: Object,
                default: () => null
            },

            unit: {
                type: Object,
                default: () => null
            },

            lease: {
                type: Object,
                default: () => null
            },

            rent: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			default_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/articles%2Fapartment-couch.jpg?alt=media&token=c0955483-0830-4201-b5fd-a2a587c3d3b3'

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			profileBackgroundStyle: function() {

                /*
                **  Set the background image tp use the unit image
                **  @prop: @here
                */

                if (this.unit.links.media.length > 0) return 'background: url(' + this.this.unit.links.media[0] + ') no-repeat center/cover';

                /*
                **  Else, set the default image
                **  @prop: @here
                */

                return 'background: url(' + this.default_image + ') no-repeat center/cover';

            },

            totalMonthlyRent: function() {

                if (this.rent) {

                    /*
                    **  Set the base rent amount
                    */

                    let amount = this.rent.attributes.amount;

                    /*
                    **  Add a transaction fee, if applicable
                    */

                    if (this.rent.attributes.transaction_fees_policy.set_policy && this.rent.attributes.transaction_fees_policy.resident.fee_amount > 0) {

                        amount = amount + this.rent.attributes.transaction_fees_policy.resident.fee_amount;

                    }

                    return amount;

                }

            }

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>